/**
 * User login information (provided by StoryHunt auth providers)
 */
export interface LoginUser {
    uid: string,
    email: string,
    firstName: string,
    lastName: string,
    displayName: any,
    providerData: any[],
    photoURL: string,
    claims: { isAdmin?: boolean, isSuperAdmin?: boolean };
    token: string;
}
